import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface RoleQuery extends PaginatableQuery, SortableQuery {
  search: string;
}

export const encodeRoleQuery = (query: RoleQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
  ...encodeSortableQuery(query),
});
